import createRequester from "rxjs-ajax-request"

// Models
import HttpServiceType from "./HttpServiceType"

// Helpers
import {resolveApiUrl, resolveWSUrl} from "../../helpers"

const HttpService: HttpServiceType = Object.create(createRequester({log: process.env.NODE_ENV !== "production"}))

HttpService.getApiUrl = function getApiUrl(): string {
    return resolveApiUrl()
}

HttpService.getWebSocketUrl = function getWebSocketUrl(): string {
    return resolveWSUrl()
}

export default HttpService
